module.exports = __webpack_public_path__ + "2c15ac99ea2cac19e659fa3441f9a66d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pos/logout.png
// module id = 469
// module chunks = 0